import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import ReactPaginate from 'react-paginate';
import Axios from 'axios';
import { useEffect, useState } from 'react'
import { domain } from '../env';
import FsLightbox from 'fslightbox-react';

export const MediaGalleryPage = () => {
    const [mediagallery, setMediagallery] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(0);
    
    // Lightbox states
    const [lightboxController, setLightboxController] = useState({
        toggler: false,
        slide: 1
    });

    const openLightboxOnSlide = (number) => {
        setLightboxController({
            toggler: !lightboxController.toggler,
            slide: number
        });
    };

    // Function to fetch media gallery with pagination
    const fetchMediaGallery = async (pageNumber = 1) => {
        setLoading(true);
        try {
            const response = await Axios.get(`${domain}/api/mediagallery/?page=${pageNumber}`);
            
            // Check if the response has the expected paginated format
            if (response.data && response.data.results) {
                setMediagallery(response.data.results);
                setPageCount(Math.ceil(response.data.count / 6));
                console.log(`Media Gallery: Page ${pageNumber} of ${Math.ceil(response.data.count / 6)}`);
            } else {
                console.warn("Response format unexpected:", response.data);
                setMediagallery([]);
            }
        } catch (error) {
            console.error("Error fetching media gallery:", error);
            setMediagallery([]);
        } finally {
            setLoading(false);
        }
    };

    // Initial data fetch on component mount
    useEffect(() => {
        fetchMediaGallery(1);
    }, []);

    // Handle page changes
    const handlePageClick = (event) => {
        const selectedPage = event.selected;
        const newPageNumber = selectedPage + 1; // API uses 1-based indexing
        
        console.log(`Changing to page ${newPageNumber}`);
        setCurrentPage(selectedPage);
        fetchMediaGallery(newPageNumber);
        
        // Scroll to top of gallery
        window.scrollTo({
            top: document.querySelector('.gallery-page').offsetTop - 100,
            behavior: 'smooth'
        });
    };
    
    // Create an array of image sources for the lightbox
    const lightboxSources = Array.isArray(mediagallery) 
        ? mediagallery.map(item => `${domain}${item?.image}`) 
        : [];

    return (
        <>
            <section className="page-header">
                <div className="page-header-bg" style={{'backgroundImage':'url(images/v.jpg)'}}>
                </div>
                <div className="container">
                    <div className="page-header__inner">
                        <h2>MEDIA GALLERY</h2>
                        <ul className="thm-breadcrumb list-unstyled">
                            <li><a href="/">Home</a></li>
                            <li><span>/</span></li>
                            <li className="active">MEDIA GALLERY</li>
                        </ul>
                    </div>
                </div>
            </section>
            
            <section className="gallery-page gallery--carousel">
                <div className="container">
                    {loading ? (
                        <div className="text-center py-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <>
                            <div className="row">
                                {Array.isArray(mediagallery) && mediagallery.length > 0 ? (
                                    mediagallery.map((mg, index) => (
                                        <div className="col-md-4" key={`media-${mg.id || index}`} style={{ marginBottom: '20px' }}>
                                            <div 
                                                onClick={() => openLightboxOnSlide(index + 1)}
                                                style={{ cursor: 'pointer' }}
                                                className="gallery-item"
                                            >
                                                <LazyLoadImage 
                                                    effect="blur" 
                                                    src={`${domain}${mg?.image}`}
                                                    style={{
                                                        'height':'280px',
                                                        'border':'1px solid #e570e7',
                                                        'borderStyle':'dashed',
                                                        'marginTop': '10px',
                                                        'width': '100%',
                                                        'objectFit': 'cover'
                                                    }}
                                                    alt={`Gallery image ${index + 1}`}
                                                    placeholder={
                                                        <div style={{ height: '280px', background: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                            <div className="spinner-border text-primary" role="status">
                                                                <span className="visually-hidden">Loading...</span>
                                                            </div>
                                                        </div>
                                                    }
                                                />
                                                <div className="gallery-item__overlay">
                                                    <span className="icon-plus"></span>
                                                    <p className="mt-2 text-white">Click to view</p>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="col-12 text-center py-5">
                                        <p>No gallery images found</p>
                                    </div>
                                )}
                            </div>
                            
                            {/* FsLightbox component for image preview */}
                            <FsLightbox
                                toggler={lightboxController.toggler}
                                sources={lightboxSources}
                                slide={lightboxController.slide}
                                type="image"
                                className="gallery-lightbox"
                            />
                            
                            {/* Pagination component */}
                            {pageCount > 1 && (
                                <div className="row mt-4">
                                    <div className="col-md-12">
                                        <div className="d-flex justify-content-center">
                                            <ReactPaginate
                                                breakLabel="..."
                                                nextLabel={<i className='fas fa-angle-double-right' />}
                                                onPageChange={handlePageClick}
                                                pageRangeDisplayed={3}
                                                marginPagesDisplayed={1}
                                                pageCount={pageCount}
                                                previousLabel={<i className='fas fa-angle-double-left' />}
                                                renderOnZeroPageCount={null}
                                                containerClassName='pagination'
                                                pageClassName='page-num'
                                                previousLinkClassName="page-num"
                                                nextLinkClassName="page-num"
                                                forcePage={currentPage}
                                                activeLinkClassName="active"
                                                disabledClassName="disabled"
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </section>
            
            {/* Add CSS for gallery item overlay */}
            <style dangerouslySetInnerHTML={{
                __html: `
                    .gallery-item {
                        position: relative;
                        overflow: hidden;
                    }
                    .gallery-item__overlay {
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        background: rgba(0,0,0,0.5);
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        opacity: 0;
                        transition: opacity 0.3s;
                        margin-top: 10px;
                    }
                    .gallery-item:hover .gallery-item__overlay {
                        opacity: 1;
                    }
                    .gallery-item .icon-plus {
                        color: white;
                        font-size: 24px;
                    }
                    
                    @media (max-width: 768px) {
                        .gallery-item__overlay {
                            opacity: 0.7;
                        }
                    }
                `
            }} />
        </>
    );
};
